export const implementationTypologies = ['CITY_CENTER', 'COMMERCIAL_CENTER', 'MINI_STORE'] as const
export type ImplementationTypology = (typeof implementationTypologies)[number]

export const implementationTypologyLabel: Record<ImplementationTypology, string> = {
  CITY_CENTER: 'Centre-ville',
  COMMERCIAL_CENTER: 'Ccial',
  MINI_STORE: 'Miniboutique',
}
